import { render, staticRenderFns } from "./ArticleDashboard.vue?vue&type=template&id=b1cf64ca"
import script from "./ArticleDashboard.vue?vue&type=script&lang=ts"
export * from "./ArticleDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports